<template>
    <div class="list-item">
        <div 
          :class="[
            (item.photo ? 'background' : ''),
            (item.link ? 'link' : ''),
            'item',
            (item.title ? 'title' : 'not-title')
          ]" 
          @click="click(item)"
        >
          <img v-if="item.photo" :src="item.photo">
          <div class="text">
            <span class="name">{{ item.name }}</span>
            <span v-if="item.post" class="post">{{ item.post }}</span>
          </div>
        </div> 
    </div>
</template>

<script>

export default {
  props: [
    'item',
    'index'
  ],

  methods: {
    click (item) {
      if (item.link) {
        if (item.internal === true) {
          this.$router.push(item.link)
        } else {
          window.open(item.link, '_blank');
        }
      }
    }
  }
}
</script>

<style lang="scss">
.ambassadors {
  .list-item {
    width: 50%;
    padding: 3px;
    @media screen and (max-width: 500px) {
      // padding-bottom: 150px;
    }
    .item {
      color: white;
      text-align: center;
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: cover;
      position: relative;
      img {
        width: 100%;
      }
      &:before {
        transition: all 0.3s ease;
        content: "";
      }

      &:hover {
        .text {
          opacity: 1;
        }
        @media screen and (min-width: 1019px) {
          &:before {
            background-color: rgba(0, 0, 0, 0.55);
            top: 0px;
            left: 0px;
            bottom: 0px;
            right: 0px;
            position: absolute;
          }
        }
      }

      &.title {
        background-color: rgba(0, 0, 0, 0.3);
        .text {
          opacity: 1;
        }
        .name {
          margin-left: -80px;
          font-family: Montserrat;
          font-size: 20px;
          text-align: left;
          @media screen and (max-width: 1300px) {
            font-size: 12px;
            margin-left: -50px;
          }

          @media screen and (max-width: 500px) {
            font-size: 22px;
          }

          @media screen and (max-width: 360px) {
            font-size: 17px;
          }
        }
      }

      &.link {
        cursor: pointer;
      }
    }

    .not-title {
      @media screen and (max-width: 768px) {
        height: 480px;
      }
      .text {
        @media screen and (max-width: 1019px) {
          opacity: 1;
          text-align: left;
          position: static;
          top: 100%;
          display: block;
          span {
            display: block;
            line-height: initial;
          }
          .name {
            width: 100%;
          }
        }

        @media screen and (max-width: 768px) {
          position: static;
          .name {
            font-size: 33px;
            line-height: 40px !important;
          }
          .post {
            line-height: initial;
            font-size: 20px;
          }
        }
      }
    }

    .text {
      transition: all 0.3s ease;
      opacity: 0;
      display: none;
      position: absolute;
      z-index: 3;
      width: 100%;
      top: 0px;
      bottom: 0px;
      flex-direction: column;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 0px;
      left: 0px;
      bottom: 0px;
      right: 0px;
      position: absolute;
      .name {
         width: 70%;
        font-size: 22px;
        font-family: 'Oswald', sans-serif;
        @media screen and (max-width: 1300px) {
          font-size: 14px;
        }

        @media screen and (max-width: 1019px) {
          font-size: 24px;
          line-height: 29px !important;
        }
      }
      .post {
        margin-top: 5px;
        line-height: 14px;
        font-size: 12px;
        @media screen and (max-width: 1300px) {
          margin-top: 0px;
          line-height: 10px;
          font-size: 8px;
        }

        @media screen and (max-width: 1019px) {
          font-size: 18px;
        }
      }
    }

  }
}
</style>